export interface Pagination {
    page: number;
}
